import { render, staticRenderFns } from "./All_Quizes.vue?vue&type=template&id=5417ed02&scoped=true&"
import script from "./All_Quizes.vue?vue&type=script&lang=js&"
export * from "./All_Quizes.vue?vue&type=script&lang=js&"
import style0 from "./All_Quizes.vue?vue&type=style&index=0&id=5417ed02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417ed02",
  null
  
)

export default component.exports